// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__R5tF0","left":"StickyBox_left__2V2cK","right":"StickyBox_right__2woI0"};